// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Stacking layer for full-screen modal dialogs. Sits above app content but below
 * .overlayContainer (context menus) because it appears earlier in the DOM — both have
 * z-index: 1, and among siblings with equal z-index the later element wins.
 *
 * Cross-reference: Menus.css (.overlayContainer), index.html (DOM order),
 * hooks/index.tsx (overlayPortal, modalPortal), Popup.tsx, Modal.tsx.
 * Update all of these if the stacking strategy changes.
 */
.modalsContainer {
  position: absolute;
  width: 0;
  height: 0;
  z-index: 1;
}

.modalBackdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(6px);
}

.modalBox {
  position: relative;
  max-width: var(--page-max-width);
  max-height: calc(100dvh - 2 * var(--page-padding));
  margin: var(--page-padding);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--modal-background);
  border: 1px solid var(--modal-border-color);
  border-radius: var(--modal-radius);
  box-shadow: 0 8px 40px #0004, var(--modal-shadow);
  box-sizing: border-box;
  width: 100%;
}

.modalBoxFillVertical {
  height: calc(100dvh - 2 * var(--page-padding));
}

.modalCloseButton {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  padding: 4px;
  border: 0;
  background: none;
  border-radius: var(--button-border-radius);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
}

.modalCloseButton:hover {
  background: #0001;
  opacity: 1;
}

.modalCloseButton:focus {
  outline: var(--outline-focus);
  opacity: 1;
}

.modalCloseButton > img {
  width: var(--icon-size);
  height: var(--icon-size);
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Modal.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;AACF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kDAAkD;EAClD,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;EACnC,2CAA2C;EAC3C,kCAAkC;EAClC,iDAAiD;EACjD,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B","sourcesContent":["/*\n * Stacking layer for full-screen modal dialogs. Sits above app content but below\n * .overlayContainer (context menus) because it appears earlier in the DOM — both have\n * z-index: 1, and among siblings with equal z-index the later element wins.\n *\n * Cross-reference: Menus.css (.overlayContainer), index.html (DOM order),\n * hooks/index.tsx (overlayPortal, modalPortal), Popup.tsx, Modal.tsx.\n * Update all of these if the stacking strategy changes.\n */\n.modalsContainer {\n  position: absolute;\n  width: 0;\n  height: 0;\n  z-index: 1;\n}\n\n.modalBackdrop {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(6px);\n}\n\n.modalBox {\n  position: relative;\n  max-width: var(--page-max-width);\n  max-height: calc(100dvh - 2 * var(--page-padding));\n  margin: var(--page-padding);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: var(--modal-background);\n  border: 1px solid var(--modal-border-color);\n  border-radius: var(--modal-radius);\n  box-shadow: 0 8px 40px #0004, var(--modal-shadow);\n  box-sizing: border-box;\n  width: 100%;\n}\n\n.modalBoxFillVertical {\n  height: calc(100dvh - 2 * var(--page-padding));\n}\n\n.modalCloseButton {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 28px;\n  height: 28px;\n  padding: 4px;\n  border: 0;\n  background: none;\n  border-radius: var(--button-border-radius);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.5;\n}\n\n.modalCloseButton:hover {\n  background: #0001;\n  opacity: 1;\n}\n\n.modalCloseButton:focus {\n  outline: var(--outline-focus);\n  opacity: 1;\n}\n\n.modalCloseButton > img {\n  width: var(--icon-size);\n  height: var(--icon-size);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
